module.exports = __webpack_public_path__ + "static/Nav-9d83449b6ed938b50cca89d8fb76d172.png";